var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('applicant-info'),_c('round-info',{attrs:{"slug":this.$route.params.slug}}),_c('comments-section'),_c('follow-up-status'),(
      _vm.hasAccess({
        permissions: [_vm.PERMISSIONS.MAIL.MENU],
        checkAll: false,
      })
    )?_c('email-conversation'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }